export type { IAgentProductHistory, IAgentResearchHistory } from '@domains/research/shared';
